import React from 'react';
import {connect} from 'react-redux';
import Const from 'constants';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersList as BasePlayersList} from 'components/organisms/used-players-list/components/players-list';
import PlayerExposure from 'components/molecules/player-exposure';
import PlayerPoints from 'components/molecules/player-points';
import PlayerExclusionSwitcher from 'components/molecules/player-exclusion/player-exclusion-switcher';
import PlayerLock from 'components/molecules/player-lock';
import TeamLogo from 'components/molecules/team-logo';
import FilterLineupsByPlayer from 'components/molecules/filter-lineups-by-player';
import PlayerInjury from 'components/molecules/player-injury';

class PlayersListComponent extends BasePlayersList {
    getPlayers() {
        const {filters} = this.props;

        const filteredPlayers = this.getFilteredUsedPlayers();

        const searchParams = {
            rosterPositionName: {
                filterType: Const.FILTER_TYPE_EQUAL,
                filterValue: filters.tier,
                dataItemCallback: function (item) {
                    return parseInt(item);
                },
            },
        };

        let players = filterObjectByParams(filteredPlayers, searchParams, true);

        return sortArrayOfObjects(players, 'usedLineupsCount', 'desc');
    }

    render() {
        const players = this.getPlayers();
        const renderKey = this.getRenderKey();

        const items = [];
        if (!isEmpty(players)) {
            Object.values(players).map((player, index) => {
                const className = index % 2 === 0 ? 'even' : '';

                items.push(
                    <tbody key={`${renderKey}${index}`} className={className}>
                        <tr>
                            <td colSpan="4" className="top-line">
                                <PlayerExclusionSwitcher
                                    className="lineups-filter-players-checkbox"
                                    playerId={player.getId()}
                                />
                                <FilterLineupsByPlayer player={player} />
                                <PlayerLock className={`lock-player lock-btn`} playerId={player.getId()} />
                                <span className={`tier tier-${player.rosterPositionName}`}>
                                    <span>{player.rosterPositionName}</span>
                                </span>
                                <TeamLogo teamName={player.team.toUpperCase()} />
                                <div className="player">
                                    <div>
                                        <span className="pos">{player.positionName.toUpperCase()}</span>
                                        <div className="name">
                                            {player.name}
                                            <PlayerInjury player={player} />
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {this.wrapContentInTooltip(
                                    <PlayerPoints
                                        className="form-control"
                                        playerId={player.getId()}
                                        propName={'userPoints'}
                                    />,
                                    `Default Score: ${player.adminPoints}`,
                                )}
                            </td>
                            <td className="text-blue">
                                <span className="inline-text">{this.calcPlayerExposure(player)}%</span>(
                                {this.calcPlayerLineupsQuantity(player)})
                            </td>
                            <td className="td-narrow">
                                <div className="percent-in">
                                    <PlayerExposure
                                        className="form-control"
                                        playerId={player.getId()}
                                        propName={'exposureMin'}
                                    />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                            <td className="td-narrow">
                                <div className="percent-in">
                                    <PlayerExposure
                                        className="form-control"
                                        playerId={player.getId()}
                                        propName={'exposureMax'}
                                    />
                                    <span className="percent">%</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>,
                );
            });
        } else {
            items.push(this.getTBodyPlayersNotFoundView({colSpan: 4}));
        }

        return (
            <div className="players-used-table table-holder">
                <div className="sticky-table">
                    <table className="players-table">
                        <tbody>
                            <tr>
                                <th>FPts</th>
                                <th>Exp%</th>
                                <th>Exp.min</th>
                                <th>Exp.max</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table className="players-table">{items}</table>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
    } = state;
    return {
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
    };
}

let PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList};
